import { render, staticRenderFns } from "./RollHistory.vue?vue&type=template&id=8fe632d4&scoped=true"
import script from "./RollHistory.vue?vue&type=script&lang=js"
export * from "./RollHistory.vue?vue&type=script&lang=js"
import style0 from "./RollHistory.vue?vue&type=style&index=0&id=8fe632d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe632d4",
  null
  
)

export default component.exports